import axios from "utils/axios";
import type { CustomAxiosRequestConfig } from "@xt/xtbase";

const URL = "/sapi/v4/payment/hyperpay/card/";

/** GET /payment/hyperpay/card/entry/status — 入口状态聚合 */
export function get_hyperpayCardEntryStatus(config?: CustomAxiosRequestConfig) {
  return axios.get(URL + "entry/status", {
    ...config,
    errorPop: false,
  });
}

/** POST /payment/hyperpay/card/apply/status — 查询最新开卡申请状态 */
export function post_hyperpayCardApplyStatus(config?: CustomAxiosRequestConfig) {
  return axios.post(URL + "apply/status", null, {
    ...config,
    errorPop: false,
  });
}
